import { PATH_APP } from "../paths";
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import AuthProtect from "src/components/Auth/AuthProtect";
import DashboardLayout from "src/layouts/DashboardLayout";
import Roles from "src/utils/Roles";

// ----------------------------------------------------------------------

const AppRoutes = {
  path: PATH_APP.tuCarta.root,
  guard: AuthProtect,
  layout: DashboardLayout,
  routes: [
    // tucarta
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.tpv,
      component: lazy(() => import("src/views/app/UserNormal/tpv")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.sessions,
      component: lazy(() => import("src/components/dev/routesSessions/index")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.dashboard,
      component: lazy(
        () =>
          import("src/views/app/UserNormal/dashboard/charts/indexFranquicia"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.mesas,
      component: lazy(() => import("src/views/app/UserNormal/mesas")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.reservas,
      component: lazy(() => import("src/views/app/UserNormal/reservas")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.pedidos,
      component: lazy(() => import("src/views/app/UserNormal/pedidosOnline")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.promociones,
      component: lazy(() => import("src/views/app/UserNormal/promociones")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.calendar,
      component: lazy(
        () => import("src/views/app/UserNormal/calendar/Calendar"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.editTable,
      component: lazy(() => import("src/views/app/UserNormal/mesas/editTable")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.printers,
      component: lazy(() => import("src/views/app/UserNormal/printers")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.stripe,
      // Legacy — redirect al nuevo Hub. Ver bloque E.
      component: lazy(
        () => import("src/views/app/UserNormal/Integrations/StripeLegacyRedirect"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.integrations,
      component: lazy(() => import("src/views/app/UserNormal/Integrations")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.integrationDetail,
      component: lazy(() => import("src/views/app/UserNormal/Integrations")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.reportsDaily,
      component: lazy(() => import("src/views/app/UserNormal/DailyReports")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.reviews,
      component: lazy(() => import("src/views/app/UserNormal/Reviews")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.reviewDetail,
      component: lazy(() => import("src/views/app/UserNormal/Reviews")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.settings,
      component: lazy(() => import("src/views/user/Settings/index")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.addPrinter,
      component: lazy(
        () => import("src/views/app/UserNormal/printers/createEditPrinter"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.editPrinter,
      component: lazy(
        () => import("src/views/app/UserNormal/printers/createEditPrinter"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.categories,
      component: lazy(() => import("src/views/app/UserNormal/categories")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.orderCategory,
      component: lazy(
        () => import("src/views/app/UserNormal/categories/orderCategory"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.addCategory,
      component: lazy(
        () => import("src/views/app/UserNormal/categories/addEditCategory"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.editCategory,
      component: lazy(
        () => import("src/views/app/UserNormal/categories/addEditCategory"),
      ),
    },
    // Tags
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.tags,
      component: lazy(() => import("src/views/app/UserNormal/tags")),
    },
    // Inventario › Precios y promociones (Happy hour · Suplementos por zona · Informe).
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.precios,
      component: lazy(() => import("src/views/app/UserNormal/precios")),
    },
    // Rutas antiguas → su pestaña.
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.priceRules,
      component: () => <Redirect to={`${PATH_APP.tuCarta.precios}?tab=happy-hour`} />,
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.zoneCharges,
      component: () => <Redirect to={`${PATH_APP.tuCarta.precios}?tab=suplementos`} />,
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.addTag,
      component: lazy(() => import("src/views/app/UserNormal/tags/addEditTag")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.editTag,
      component: lazy(() => import("src/views/app/UserNormal/tags/addEditTag")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.orderTags,
      component: lazy(() => import("src/views/app/UserNormal/tags/orderTags")),
    },
    // Displays
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.displays,
      component: lazy(() => import("src/views/app/UserNormal/displays")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.displayAdd,
      component: lazy(
        () => import("src/views/app/UserNormal/displays/addEditDisplay"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.displayEdit,
      component: lazy(
        () => import("src/views/app/UserNormal/displays/addEditDisplay"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN, Roles.USER_EMPLOYEE],
      path: PATH_APP.tuCarta.caja,
      component: lazy(() => import("src/views/app/UserNormal/caja/index")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.discount,
      component: lazy(() => import("src/views/app/UserNormal/discounts/index")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.editDiscount,
      component: lazy(
        () => import("src/views/app/UserNormal/discounts/addEditDiscount"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.addDiscount,
      component: lazy(
        () => import("src/views/app/UserNormal/discounts/addEditDiscount"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.productos,
      component: lazy(
        () => import("src/views/app/UserNormal/products/EcommerceProductList"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.newProducto,
      component: lazy(
        () =>
          import("src/views/app/UserNormal/products/product-new/EcommerceProductCreate"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.producto,
      component: lazy(
        () =>
          import("src/views/app/UserNormal/products/product-new/EcommerceProductCreate"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.logs,
      component: lazy(() => import("src/views/app/UserNormal/logs/index")),
    },
    {
      exact: true,
      path: PATH_APP.tuCarta.invoices,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      component: lazy(
        () => import("src/components/functionality/Invoices/userNormal/index"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.employees,
      component: lazy(() => import("src/views/app/UserNormal/employees")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.editEmployee,
      component: lazy(
        () => import("src/views/app/UserNormal/employees/createEdit"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.createEmployee,
      component: lazy(
        () => import("src/views/app/UserNormal/employees/createEdit"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.editEmployeeRole,
      component: lazy(
        () =>
          import("src/views/app/UserNormal/employees/EmployeeRoles/CreateEditEmployeeRolesForm"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.createEmployeeRole,
      component: lazy(
        () =>
          import("src/views/app/UserNormal/employees/EmployeeRoles/CreateEditEmployeeRolesForm"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.employeeHolidays,
      component: lazy(
        () => import("src/views/app/UserNormal/employees/holidays/HolidayCalendarsView"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.workSchedules,
      component: lazy(
        () => import("src/views/app/UserNormal/employees/workSchedules/WorkSchedulesView"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.rotationsV2,
      component: lazy(
        () => import("src/views/app/UserNormal/employees/rotationsV2/RotationsV2View"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.logs,
      component: lazy(() => import("src/views/app/UserNormal/logs")),
    },
    // Estadísticas (bajo facturación)
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.estadisticas,
      component: lazy(() => import("src/views/app/UserNormal/dashboard/charts/indexFranquicia")),
    },
    // 2026-09-11 · Estadísticas V2 (rediseño ejecutivo). Componente
    // nuevo con hero KPIs + heatmap horario + panel fiscal + informes
    // automáticos. Ruta separada + switch en la vista antigua para
    // rollout gradual sin romper nada.
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.estadisticasV2,
      component: lazy(() => import("src/views/app/UserNormal/dashboard/estadisticasV2")),
    },
    // Gestión — add/edit forms (need own routes for URL params)
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionRecetaEditor,
      component: lazy(() => import("src/views/app/UserNormal/gestion/recetas/editor")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionEscandalloIA,
      component: lazy(() => import("src/views/app/UserNormal/gestion/escandalloIA")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionIngredienteAdd,
      component: lazy(() => import("src/views/app/UserNormal/gestion/ingredientes/addEdit")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionIngredienteEdit,
      component: lazy(() => import("src/views/app/UserNormal/gestion/ingredientes/addEdit")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionProveedorAdd,
      component: lazy(() => import("src/views/app/UserNormal/gestion/proveedores/addEdit")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionProveedorEdit,
      component: lazy(() => import("src/views/app/UserNormal/gestion/proveedores/addEdit")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionElaboracionAdd,
      component: lazy(() => import("src/views/app/UserNormal/gestion/elaboraciones/addEdit")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionElaboracionEdit,
      component: lazy(() => import("src/views/app/UserNormal/gestion/elaboraciones/addEdit")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionOrdenAdd,
      component: lazy(() => import("src/views/app/UserNormal/gestion/compras/addOrden")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionAlbaranAdd,
      component: lazy(() => import("src/views/app/UserNormal/gestion/compras/addAlbaran")),
    },
    // 2026-10 · «Inventario y costes» (hub). Dashboard y Operaciones de
    // Gestión redirigen a la pestaña equivalente.
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.inventario,
      component: lazy(() => import("src/views/app/UserNormal/inventario")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestionOperaciones,
      component: lazy(() =>
        import("src/views/app/UserNormal/inventario/LegacyRedirects").then((m) => ({ default: m.GestionOperacionesRedirect })),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.gestion,
      component: lazy(() =>
        import("src/views/app/UserNormal/inventario/LegacyRedirects").then((m) => ({ default: m.GestionDashboardRedirect })),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.root,
      component: () => <Redirect to={PATH_APP.tuCarta.tpv} />,
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.factura,
      component: lazy(
        () => import("src/components/functionality/Factura/userNormal"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.facturaEdit,
      component: lazy(
        () =>
          import("src/components/functionality/Factura/userNormal/FacturaAdd"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.facturaAdd,
      component: lazy(
        () =>
          import("src/components/functionality/Factura/userNormal/FacturaAdd"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.paymentMethods,
      component: lazy(
        () => import("src/views/app/UserNormal/paymentMethods/index"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.monitor,
      component: lazy(() => import("src/views/app/UserNormal/monitor")),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.paymentMethodAdd,
      component: lazy(
        () =>
          import("src/views/app/UserNormal/paymentMethods/PaymentMethodsCreateEdit"),
      ),
    },
    {
      exact: true,
      role: [Roles.USER_NORMAL, Roles.USER_ADMIN],
      path: PATH_APP.tuCarta.paymentMethodEdit,
      component: lazy(
        () =>
          import("src/views/app/UserNormal/paymentMethods/PaymentMethodsCreateEdit"),
      ),
    },
    {
      component: () => <Redirect to="/404" />,
    },
  ],
};

export default AppRoutes;
